module.exports = __webpack_public_path__ + "static/media/ambient_off.5c93acc1.png";